<div class="position-relative">
    <div class="container-fluid bg-lightblue">
        <div class="container-xxxl py-5 py-lg-4">
            <div class="row align-items-stretch my-0 my-lg-5 py-lg-2">
                <div class="col-lg-4 d-flex mb-4 mb-lg-0 d-print-none">
                    <div class="ratio ratio-16x9 flex-fill h-100 overflow-hidden rounded-3">
                        <img class="object-fit-cover" [src]="imageUrl" [alt]="contentArticle.images[0]?.altText" />
                    </div>
                </div>

                <div class="col-lg-7 offset-lg-1">
                    <div class="container-fluid pb-32">
                        <div class="row">
                            <h1 class="section-heading text-blue border-blue">{{ contentArticle.title }}</h1>
                        </div>
                    </div>
                    <clamper class="d-block py-lg-4" [maxLines]="bodyMaxLines" [text]="contentArticle.bodyText"></clamper>

                    <div class="about-gard-action mt-4 mt-lg-0">
                        <a class="btn btn-arrow text-white btn-green blue-effect" [routerLink]="aboutUrl" routerLinkActive="active">
                            <span [innerHTML]="buttonArticle.title"></span>
                            <i class="icon-gard-arrow-right ms-1"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
